<template>
  <span class="notifications-card-icon">
    <svg v-if="type === 'voice'" :class="['icon', iconClass]" :style="styles" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 16 16" style="width: 1em; height: 1em; vertical-align: middle">
      <g fill-rule="evenodd">
        <path d="M2 11A1.333 1.333 0 0 1 .667 9.667V6.333C.667 5.597 1.264 5 2 5h.855c.31 0 .609-.107.848-.304L7.364 1.68A1 1 0 0 1 9 2.452v11.096a1 1 0 0 1-1.636.772l-3.661-3.016A1.333 1.333 0 0 0 2.855 11H2z" />
        <path
          fill-rule="nonzero"
          d="M12.794 2.584a.667.667 0 0 1 .812 1.056l-.043.033-2.179 1.538a.667.667 0 0 1-.812-1.056l.044-.033 2.178-1.538zM14.333 7.333a.667.667 0 0 1 .05 1.332l-.05.002h-2.666a.667.667 0 0 1-.05-1.332l.05-.002h2.666zM12.794 13.494a.667.667 0 0 0 .812-1.056l-.043-.034-2.179-1.538a.667.667 0 0 0-.812 1.056l.044.034 2.178 1.538z"
          opacity=".6"
        />
      </g>
    </svg>
    <svg v-if="type === 'prod'" width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Icon_产品通知</title>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Icon_产品通知">
          <circle id="椭圆形" fill="#FFE4D6" cx="16" cy="16" r="16" />
          <g id="编组" transform="translate(8.000000, 8.000000)" fill="#F76A31">
            <rect id="矩形" x="0" y="0" width="7.55555556" height="7.55555556" rx="1.77777778" />
            <circle id="椭圆形" opacity="0.303321475" cx="12.2222222" cy="3.77777778" r="3.77777778" />
            <rect id="矩形备份" x="0" y="8.44444444" width="7.55555556" height="7.55555556" rx="1.77777778" />
            <rect id="矩形备份-3" x="8.44444444" y="8.44444444" width="7.55555556" height="7.55555556" rx="1.77777778" />
          </g>
        </g>
      </g>
    </svg>
    <svg v-if="type === 'close'" :class="['icon', iconClass]" :style="styles" t="1658798975862" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2249" width="200" height="200" @click="onClick">
      <path
        d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
        p-id="2250"
      />
    </svg>
    <svg v-if="type === 'right'" :class="['icon', iconClass]" :style="styles" t="1658799044198" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3150" width="200" height="200" @click="onClick">
      <path d="M760.768 576L384 931.84 469.76 1024 1024 515.392 474.048 0 384 98.88 753.6 448H0v128h760.768z" fill="#262626" p-id="3151" />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'IconSvg',
  props: {
    type: {
      type: String,
      default: '',
    }, // voice  close  right
    styles: {
      type: Object,
      default() {
        return {};
      },
    },
    iconClass: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
  setup(_, { emit }) {
    return {
      onClick() {
        emit('click');
      },
    };
  },
};
</script>
